import React from 'react';
import PropTypes from 'prop-types';
import { Input, Row, Col, Label } from 'reactstrap';
import { makeUniqueId } from '@apollo/client/utilities';

const data = new Array(4).fill().map((d, i) => (
  <option key={makeUniqueId(Date.now())} value={i + 1}>
    {i + 1}
  </option>
));

function FriendsComponent({ values, handleChange, handleBlur }) {
  return (
    <Row lg={12} className="mb-1">
      <Col lg={3}>
        <Label htmlFor="friends" className="label-road-input">
          Cantidad de amigos
        </Label>
        <Input
          type="select"
          name="friends"
          id="friends"
          placeholder="Maximo 4"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.friends}
          required
        >
          {data}
        </Input>
      </Col>
    </Row>
  );
}

FriendsComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired
};

export default FriendsComponent;
